import React from "react";
import transition from "./transition";
import "../style/Contact.css";
import contactImage from "../assets/sitting.png";
import { FaInstagram, FaYoutube } from "react-icons/fa6";

const Contact = () => {
    return (
        <div className="contact-container">
            {/* Centered Contact Info */}
            <div className="contact-content">
                <h1>DIRECTING - CHOREOGRAPHY - WORKSHOPS</h1>
                <p className="email">JOSHUA SMITH MANAGEMENT @ GMAIL . COM</p>
                <div className="social-icons">
                    <a href="https://www.instagram.com/dancer_boysmith/" target="_blank" rel="noopener noreferrer">
                        <FaInstagram className="icon" />
                    </a>
                    {/* TODO: Get the Twitter link or Youtube Link*/}
                    <a href="https://www.youtube.com/@dancerboysmith" target="_blank" rel="noopener noreferrer">
                        <FaYoutube className="icon" />
                    </a>
                </div>
            </div>

            {/* Right-Side Image */}
            <div className="contact-image">
                <img src={contactImage} alt="Joshua Smith" />
            </div>
        </div>
    );
};

export default transition(Contact);
